import React, { useState, useRef, useEffect } from "react";
import ListInfo from "../CourseInfo/Course/CourseInfoCreate.module.css";
import styles from "./ListCourseInfo.module.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../../../axios";
import { styled } from "@mui/material/styles";
import Loader from "../../Loader";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Pagination from "../../../ReusuableComponent/Pagination/Pagination";
import CustomDownloadButton from "../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import { R_PER_PAGE } from "../../../../labels";
import moment from "moment";
import ConfirmationPopup from "../TestAdminWorkflow/Gallery/ConfirmationPopup/ConfirmationPopup";
import toast from "react-hot-toast";
// import { ExportTableToPdf } from "../../../ReusuableComponent/ExportTableToPdf";

function ListCourseInfo() {
  const location = useLocation();
  const { filType, filCateCode, filSubCate, filGroupCourse, filSearch } =
    location.state || {};

  const txtBSearch = useRef(null);
  let page = R_PER_PAGE;
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [categoryId, setCategoryId] = useState([]);
  const [updateListData, setUpdateListData] = useState();
  const [updateChipData, setUpdateChipData] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const [isOpen, setIsOpen] = useState({
    type: false,
    category: false,
    subcategory: false,
    groupCourseName: false,
  });
  const [csvData, setCsvData] = useState([]);
  const [typeOn, setTypeOn] = useState([]);
  const [category_on, setCategory_on] = useState([]);
  const [subCategory_on, setSubCategory_on] = useState([]);
  const [groupCourse_on, setGroupCourse_on] = useState([]);
  const filterCategoryRef = useRef(null);
  const filterTypeRef = useRef(null);
  const filterSubcategoryRef = useRef(null);
  const filterGroupCourseRef = useRef(null);
  let filterSearch = [];
  let filterCategory = [];
  let filterType = [];
  let filterSubCategory = [];
  let filterGroupCourse = [];
  const [searchGroupName, setSearchGroupName] = useState("");
  const [searchSubCategory, setSearchSubCategory] = useState("");
  const [uniqueSubCategory, setUniqueSubCategory] = useState([]);
  const [uniqueGroupCourse, setUniqueGroupCourse] = useState([]);
  useEffect(() => {
    if (updateListData) {
      const filtered = Array.from(
        new Map(
          updateListData.map((item) => [item.subcategory_id, item])
        ).values()
      );
      setUniqueSubCategory(filtered);
    }
  }, [updateListData]);

  useEffect(() => {
    if (updateListData) {
      const filtered = Array.from(
        new Map(
          updateListData.map((item) => [item.group_course_id, item])
        ).values()
      );
      setUniqueGroupCourse(filtered);
    }
  }, [updateListData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");

      if (isCheckbox || isApplyFilterButton || isChipData) return;

      // CATEGORY FILTER
      if (
        filterCategoryRef.current &&
        !filterCategoryRef.current.contains(event.target)
      ) {
        const hasCategory = updateChipData.some(
          (chipItem) => chipItem.type === "category_on"
        );

        if (hasCategory) {
          const updatedCategory = updateChipData.filter(
            (chipItem) => chipItem.type === "category_on"
          );
          setCategory_on(updatedCategory);
        } else {
          setCategory_on([]);
        }
        setIsOpen((prev) => ({ ...prev, category: false }));
      }

      // TYPE FILTER
      if (
        filterTypeRef.current &&
        !filterTypeRef.current.contains(event.target)
      ) {
        const hasType = updateChipData.some(
          (chipItem) => chipItem.type === "typeOn"
        );

        if (hasType) {
          const updatedType = updateChipData.filter(
            (chipItem) => chipItem.type === "typeOn"
          );
          setTypeOn(updatedType);
        } else {
          setTypeOn([]);
        }

        setIsOpen((prev) => ({ ...prev, type: false }));
      }

      // SUBCATEGORY FILTER
      if (
        filterSubcategoryRef.current &&
        !filterSubcategoryRef.current.contains(event.target)
      ) {
        const subCategoryMatch = updateChipData.some(
          (chipItem) => chipItem.type === "subCategory_on"
        );

        if (subCategoryMatch) {
          const updatedSubCategory = updateChipData.filter(
            (chipItem) => chipItem.type === "subCategory_on"
          );
          setSubCategory_on(updatedSubCategory);
        } else {
          setSubCategory_on([]);
        }

        setIsOpen((prev) => ({ ...prev, subcategory: false }));
      }

      // GROUP COURSE FILTER
      if (
        filterGroupCourseRef.current &&
        !filterGroupCourseRef.current.contains(event.target)
      ) {
        const groupCourseMatch = updateChipData.some(
          (chipItem) => chipItem.type === "groupCourse_on"
        );

        if (groupCourseMatch) {
          const updatedGroupName = updateChipData.filter(
            (chipItem) => chipItem.type === "groupCourse_on"
          );
          setGroupCourse_on(updatedGroupName);
        } else {
          setGroupCourse_on([]);
        }

        setIsOpen((prev) => ({ ...prev, groupCourseName: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, subCategory_on, groupCourse_on, category_on]);

  useEffect(() => {
    filterCategory = category_on;
  }, [category_on]);
  useEffect(() => {
    filterType = typeOn;
  }, [typeOn]);
  useEffect(() => {
    filterSubCategory = subCategory_on;
  }, [subCategory_on]);
  useEffect(() => {
    filterGroupCourse = groupCourse_on;
  }, [groupCourse_on]);
  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);

  useEffect(() => {
    if (updateChipData?.length > 0) {
      loadListdata();
    }
  }, [updateChipData]);

  useEffect(() => {
    const hasFilterChips = updateChipData?.length === 0;
    const noSpecificFilters =
      (!filType || filType.length === 0) &&
      (!filCateCode || filCateCode.length === 0) &&
      (!filSubCate || filSubCate.length === 0) &&
      (!filGroupCourse || filGroupCourse.length === 0) &&
      (!filSearch || filSearch.length === 0);

    if (hasFilterChips && noSpecificFilters) {
      loadListdata();
    }
  }, [
    updateChipData,
    filType,
    filCateCode,
    filSubCate,
    filGroupCourse,
    filSearch,
  ]);

  useEffect(() => {
    if (filType && filType.length > 0) {
      setTypeOn(filType);
      filterType = filType;
    }
    if (filSubCate && filSubCate.length > 0) {
      setSubCategory_on(filSubCate);
      filterSubCategory = filSubCate;
    }
    if (filGroupCourse && filGroupCourse.length > 0) {
      setGroupCourse_on(filGroupCourse);
      filterGroupCourse = filGroupCourse;
    }
    if (filSearch && filSearch.length > 0) {
      setSearchTerm(filSearch);
      filterSearch = [{ name: "" + filSearch, type: "search" }];
    }
    if (filCateCode && filCateCode.length > 0) {
      setCategory_on(filCateCode);
      filterCategory = filCateCode;
    }
    loadChipdata();
  }, []);

  function updateStateData() {
    filterType = typeOn;
    filterCategory = category_on;
    filterGroupCourse = groupCourse_on;
    filterSubCategory = subCategory_on;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }

  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  const handleSort = (event, sortKey) => {
    event.preventDefault();

    const order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);

    const sortedList = [...updateListData].sort((a, b) => {
      const aVal = a[sortKey] ?? "";
      const bVal = b[sortKey] ?? "";

      // Numeric sort if both values are numbers
      if (!isNaN(aVal) && !isNaN(bVal)) {
        return order === "asc" ? aVal - bVal : bVal - aVal;
      }

      // String sort (case-insensitive)
      if (typeof aVal === "string" && typeof bVal === "string") {
        return order === "asc"
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }

      // Default fallback
      return 0;
    });

    setUpdateListData(sortedList);
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { value, checked, name } = event.target;
    const newItem = { id: value, name: name, type: typename };
    const updateState = (current, setState) => {
      if (checked) {
        // Add item
        setState([...current, newItem]);
      } else {
        // Remove item
        setState(current.filter((item) => item.id !== value));
      }
    };
    if (typename === "category_on") {
      updateState(category_on, setCategory_on);
    } else if (typename === "typeOn") {
      updateState(typeOn, setTypeOn);
    } else if (typename === "subCategory_on") {
      updateState(subCategory_on, setSubCategory_on);
    } else if (typename === "groupCourse_on") {
      updateState(groupCourse_on, setGroupCourse_on);
    }
  };

  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  const handleApplyFilter = (name, event) => {
    updateStateData();
    if (name === "category_on") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        category: false,
      });
    } else if (name === "typeOn") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        type: false,
      });
    } else if (name === "subCategory_on") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        subcategory: false,
      });
    } else if (name === "groupCourseName") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        groupCourseName: false,
      });
    }
  };
  useEffect(() => {
    AxiosInstance.get("api/course/category_list")
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          setIsLoading(false);
          setCategoryId(res.data.data);
        } else if (res.data.status === false) {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }, []);

  function loadListdata() {
    const statusFilter = {
      type: typeOn.length > 0 ? typeOn.map((obj) => Number(obj.id)) : "",
      category:
        category_on.length > 0 ? category_on.map((obj) => Number(obj.id)) : "",
      search: searchTerm.trim() !== "" ? searchTerm : "",
      group_course_id:
        groupCourse_on.length > 0
          ? groupCourse_on.map((obj) => Number(obj.id))
          : "",
      subcategory_id:
        subCategory_on.length > 0
          ? subCategory_on.map((obj) => Number(obj.id))
          : "",
    };

    setIsLoading(true);
    AxiosInstance.post("/api/course/courselist", statusFilter)
      .then((res) => {
        if (res.data.status) {
          setCurrentPage(1);
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            course_name: item.course_name,
            type:
              item.type === 0
                ? "Course"
                : item.type === 1
                ? "Test Batch"
                : item.type === 3
                ? "Special Class"
                : item.type === 2
                ? "Counselling"
                : item.type === 5
                ? "Mock Interview"
                : "Model Exam",
            category: item.category,
            group_course_name: item.group_course_name,
            subcategory: item.subcategory,
            created_dt: moment(item.created_dt).isValid()
              ? moment(item.created_dt).format("DD/MM/YYYY")
              : "-",
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        return error;
      });
  }

  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterCategory.map((obj) => {
      tempArr.push(obj);
    });
    filterType.map((obj) => {
      tempArr.push(obj);
    });
    filterGroupCourse.map((obj) => {
      tempArr.push(obj);
    });
    filterSubCategory.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  // filter clear button
  const handleClear = (name, event) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      type: false,
      category: false,
      subcategory: false,
      groupCourseName: false,
    });
    if (name === "category_on") {
      setCategory_on([]);
      filterCategory = [];
    } else if (name === "typeOn") {
      setTypeOn([]);
      filterType = [];
    } else if (name === "groupCourse_on") {
      setGroupCourse_on([]);
      filterGroupCourse = [];
      setSearchGroupName("");
    } else if (name === "subCategory_on") {
      setSubCategory_on([]);
      filterSubCategory = [];
      setSearchSubCategory("");
    }
  };
  const handleDelete = (chipToDelete) => () => {
    const updatedChips = updateChipData.filter(
      (item) =>
        !(item.type === chipToDelete.type && item.id === chipToDelete.id)
    );
    setUpdateChipData(updatedChips);

    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "subCategory_on") {
      const filterSubCategory = subCategory_on.filter(
        (item) => item.id !== chipToDelete.id
      );
      setSubCategory_on(filterSubCategory);
    } else if (chipToDelete.type === "groupCourse_on") {
      const filterGroupCourse = groupCourse_on.filter(
        (item) => item.id !== chipToDelete.id
      );
      setGroupCourse_on(filterGroupCourse);
    } else if (chipToDelete.type === "typeOn") {
      const filterType = typeOn.filter((item) => item.id !== chipToDelete.id);
      setTypeOn(filterType);
    } else if (chipToDelete.type === "category_on") {
      const filterCategory = category_on.filter(
        (item) => item.id !== chipToDelete.id
      );
      setCategory_on(filterCategory);
    }
    // loadChipdata();
  };

  const handleAllClear = () => {
    setSearchTerm("");
    setSubCategory_on([]);
    setGroupCourse_on([]);
    setTypeOn([]);
    setCategory_on([]);
    setIsOpen({
      type: false,
      category: false,
      subcategory: false,
      groupCourseName: false,
    });
    filterSearch = [];
    filterCategory = [];
    filterType = [];
    filterSubCategory = [];
    filterGroupCourse = [];
    setUpdateChipData([]);

    navigate(location.pathname, { replace: true });
  };
  useEffect(() => {
    if (location.state) {
    }
  }, [location.state]);

  useEffect(() => {
    if (location.state) {
      const timer = setTimeout(() => {
        navigate(location.pathname, { replace: true, state: null });
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  const handleFilter = (e, boxName) => {
    if (boxName === "category") {
      setIsOpen((prevState) => ({
        type: false,
        groupCourseName: false,
        subcategory: false,
        category: !prevState.category,
      }));
      setCategory_on(updateChipData.filter((ui) => ui.type === "category_on"));
    } else if (boxName === "type") {
      setIsOpen((prevState) => ({
        category: false,
        groupCourseName: false,
        subcategory: false,
        type: !prevState.type,
      }));
      setTypeOn(updateChipData.filter((ui) => ui.type === "typeOn"));
    } else if (boxName === "subcategory") {
      setIsOpen((prevState) => ({
        category: false,
        type: false,
        groupCourseName: false,
        subcategory: !prevState.subcategory,
      }));
    } else if (boxName === "groupCourseName") {
      setIsOpen((prevState) => ({
        category: false,
        type: false,
        subcategory: false,
        groupCourseName: !prevState.groupCourseName,
      }));
    }
  };

  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);

  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentData = updateListData?.slice(start, end);

  const handleChangeBookOrder = (e, id) => {
    setSelectedCourse((prev) => {
      let updatedCourse;
      if (e.target.checked) {
        const bookToAdd = currentData.find((book) => book.id === id);
        if (bookToAdd) {
          updatedCourse = [...prev, bookToAdd];
        } else {
          updatedCourse = prev;
        }
      } else {
        updatedCourse = prev.filter((book) => book.id !== id);
      }
      return updatedCourse;
    });
  };

  const handleRemoveCourse = () => {
    const courseIds = selectedCourse.map((course) => course.id);
    AxiosInstance.post("api/course/delete/course", { id: courseIds })
      .then((res) => {
        if (res.data.status === true) {
          toast.success(res.data.message);
          setSelectedCourse([]);
          handleClose();
          loadListdata();
        } else {
          toast.error(res.data.message || "Failed to delete course");
        }
      })
      .catch((error) => {
        console.error("Delete failed:", error);
        toast.error("Something went wrong while deleting.");
      });
  };

  const handleReadView = (id) => {
    navigate(`/ViewCourse/${id}`, {
      state: {
        FCAT: category_on,
        FTYPE: typeOn,
        FGROUPCOURSE: groupCourse_on,
        FSUBCATEGORY: subCategory_on,
        FSEARCHTERM: searchTerm,
      },
    });
  };

  // --------New code (Search Icon)----
  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();

      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });

      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };
  const generatePDF = () => {
    const headers = [
      // "S.No",
      "Course",
      "Type of Admission",
      "Category",
      "Course Group Name",
      "Sub Category",
      "Created On",
    ];

    const rows = csvData.map((item, index) => [
      // index + 1,
      item.course_name ?? "",
      item.type === 0
        ? "Course"
        : item.type === 1
        ? "Test Batch"
        : item.type === 3
        ? "Special Class"
        : item.type === 2
        ? "Counselling"
        : item.type === 5
        ? "Mock Interview"
        : "Model Exam",
      item.category ?? "",
      item.group_course_name ?? "",
      item.subcategory ?? "",
      item.created_dt && moment(item.created_dt).isValid()
        ? moment(item.created_dt).format("DD/MM/YYYY")
        : "-",
    ]);
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Course Data",
          headers,
          rows,
          filename: "Course.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Course", key: "course_name" },
    { label: "Type of Admission", key: "type" },
    { label: "Category", key: "category" },
    { label: "Course Group Name", key: "group_course_name" },
    { label: "Sub Category", key: "subcategory" },
    { label: "Created on", key: "created_dt" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      {showModal && (
        <ConfirmationPopup
          open={showModal}
          title="Remove Course(s)"
          message="Are you sure you want to remove the selected course(s)?"
          onConfirm={handleRemoveCourse}
          onCancel={handleClose}
        />
      )}
      <div
        className={`${ListInfo.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid  global_container p-0`}
      >
        {/* ---------------------------------------------------------------- */}
        <div className="row ">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div class="input-group ">
              <input
                ref={txtBSearch}
                type="text"
                class={styles.Inputs}
                id="SearchInput"
                name="SearchInput"
                placeholder="Search by course"
                onKeyDown={handleSearch}
              />
              <span
                class={styles.input_group_text}
                id="SearchInput"
                onClick={handleSearchFocus}
              >
                <span
                  className="material-icons"
                  // onClick={handleSearchFocus}
                >
                  search
                </span>
              </span>
            </div>
          </div>

          <div className="col-md-12 col-lg-8 ListBtn">
            <ul class="List-Button">
              <li className="ListBtnItems">
                <Link
                  // as="button"
                  to="javascript:void(0)"
                  onClick={() => {
                    if (selectedCourse.length > 0) {
                      handleShow();
                    }
                  }}
                  className={`primaryButton ${
                    selectedCourse.length > 0 ? "" : "disabledbtn"
                  }`}
                  variant="primary"
                  disabled={selectedCourse.length === 0}
                >
                  Remove Course(s)
                </Link>
              </li>

              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData?.length > 0 ? csvData : ""}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"Course.csv"}
                  csvName="  Download as CSV"
                />
              </li>
              <li class="ListBtnItems primaryButton" onClick={generatePDF}>
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                Download as PDF
              </li>
              <li class="ListBtnItems">
                <Link
                  to="/AddCourse"
                  className="primaryButton "
                  variant="primary"
                >
                  Create New Course
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {updateChipData?.length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData.map((data, index) => {
                  let icon;
                  let keyss = "";
                  let keyWords = "";

                  if (data.type === "category_on") {
                    keyss = "Category";
                    keyWords = " " + data.name;
                  } else if (data.type === "subCategory_on") {
                    keyss = "Sub Category";
                    keyWords = " " + data.name;
                  } else if (data.type === "groupCourse_on") {
                    keyss = "Course Group Name";
                    keyWords = " " + data.name;
                  } else if (data.type === "typeOn") {
                    keyss = "Type of Admission ";

                    if (data.name === "MockInterview") {
                      keyWords = " Mock Interview";
                    } else if (data.name === "TestBatch") {
                      keyWords = " Test Batch";
                    } else if (data.name === "ModelExam") {
                      keyWords = " Model Exam";
                    } else if (data.name === "SpecialClass") {
                      keyWords = " Special Class";
                    } else {
                      keyWords = " " + data.name;
                    }
                  } else {
                    keyss = "";
                    keyWords = " " + data.name;
                  }

                  return (
                    <ListItem key={index}>
                      <Chip
                        icon={icon}
                        label={
                          <>
                            <span className={styles.BoldTy}>{keyss}</span>
                            <span className={styles.BoldTyText}>
                              {keyWords}
                            </span>
                          </>
                        }
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}

                {/* Show Clear All Filters once at the end */}
                <ListItem>
                  <a
                    className={styles.allclear}
                    href="javascript:void(0)"
                    onClick={handleAllClear}
                  >
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        <div className="row mx-0 mt-2">
          <div className="col-md-12 table-responsive tableMinHeight px-0">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  <th id="th" className={styles.tableThPadding}></th>
                  {/* S.No. */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      S.No
                    </span>
                    <span
                      className={`textHead_th material-icons align-middle`}
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export{" "}
                    </span>
                  </th>
                  {/* Course */}
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "course_name")}
                    >
                      {" "}
                      Course
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "course_name")}
                    >
                      import_export
                    </span>{" "}
                  </th>
                  {/* Type of Admission */}
                  <th id="th" ref={filterTypeRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "type")}
                    >
                      {" "}
                      Type of Admission
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "type")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      className={`textHead_th align-middle material-icons ${
                        typeOn.length > 0 || isOpen.type
                          ? ListInfo.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "type")}
                    >
                      filter_list
                    </span>
                    {isOpen.type && (
                      <>
                        <div className="filterBoxs_testlist">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="Course"
                                  value="0"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "0") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(e, "Course", "typeOn")
                                  }
                                  id="Course"
                                />
                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="Course"
                                >
                                  Course
                                </label>
                              </li>
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="TestBatch"
                                  value="1"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "1") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "TestBatch",
                                      "typeOn"
                                    )
                                  }
                                  id="TestBatch"
                                />
                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="TestBatch"
                                >
                                  Test Batch
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="SpecialClass"
                                  value="3"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "3") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "SpecialClass",
                                      "typeOn"
                                    )
                                  }
                                  id="SpecialClass"
                                />
                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="SpecialClass"
                                >
                                  Special Class
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="Counselling"
                                  value="2"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "2") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "Counselling",
                                      "typeOn"
                                    )
                                  }
                                  id="Counselling"
                                />
                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="Counselling"
                                >
                                  Counselling
                                </label>
                              </li>

                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="MockInterview"
                                  value="5"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "5") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "MockInterview",
                                      "typeOn"
                                    )
                                  }
                                  id="MockInterview"
                                />
                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="MockInterview"
                                >
                                  Mock Interview
                                </label>
                              </li>
                              <li className="filterListData">
                                <input
                                  className="ListCheckbox"
                                  type="checkbox"
                                  name="ModelExam"
                                  value="4"
                                  checked={typeOn.some((element) => {
                                    if (element.id === "4") {
                                      return true;
                                    }
                                    return false;
                                  })}
                                  onChange={(e) =>
                                    handleCheckboxChange(
                                      e,
                                      "ModelExam",
                                      "typeOn"
                                    )
                                  }
                                  id="ModelExam"
                                />
                                <label
                                  className="form-check-label filterChipText filterChipText_withoutBG"
                                  htmlFor="ModelExam"
                                >
                                  Model Exam
                                </label>
                              </li>
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("typeOn")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={typeOn.length === 0 ? true : false}
                                  onClick={() => handleApplyFilter("typeOn")}
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  {/* Category */}
                  <th id="th" ref={filterCategoryRef}>
                    <span
                      className="textHead_th px-1"
                      onClick={(e) => handleSort(e, "category")}
                    >
                      Category
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "category")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      className={`textHead_th align-middle material-icons ${
                        category_on.length > 0 || isOpen.category
                          ? ListInfo.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "category")}
                    >
                      filter_list
                    </span>
                    {isOpen.category && (
                      <>
                        <div className="filterBoxs_testlist">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              {categoryId.map((el) => (
                                <li className="filterListData">
                                  <input
                                    className="ListCheckbox"
                                    type="checkbox"
                                    name={el.name}
                                    value={el.id}
                                    id={el.name}
                                    checked={category_on.some((element) => {
                                      if (element.name == el.name) {
                                        return true;
                                      }
                                      return false;
                                    })}
                                    onChange={(e) =>
                                      handleCheckboxChange(
                                        e,
                                        el.name,
                                        "category_on"
                                      )
                                    }
                                  />
                                  <label
                                    className="form-check-label filterChipText_withoutBG "
                                    htmlFor={el.name}
                                  >
                                    {el.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() => handleClear("category_on")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>

                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    category_on.length === 0 ? true : false
                                  }
                                  onClick={() =>
                                    handleApplyFilter("category_on")
                                  }
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  <th id="th" ref={filterGroupCourseRef}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "group_course_name")}
                    >
                      {" "}
                      Course Group Name
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "group_course_name")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      className={`textHead_th align-middle material-icons ${
                        groupCourse_on.length > 0 || isOpen.groupCourseName
                          ? ListInfo.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "groupCourseName")}
                    >
                      filter_list
                    </span>
                    {isOpen.groupCourseName && (
                      <>
                        <div className="filterBoxs_testlist">
                          <div className="col-md-12 form-check filterStatus_list">
                            <div
                              className="input-group"
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 10,
                                backgroundColor: "white",
                                padding: "8px",
                              }}
                            >
                              <input
                                type="text"
                                className={styles.Inputs}
                                id="SearchInput"
                                name="SearchInput"
                                value={searchGroupName}
                                placeholder="Search by subject"
                                onChange={(e) =>
                                  setSearchGroupName(e.target.value)
                                }
                              />
                              <span className={styles.input_group_text}>
                                <span className="material-icons">search</span>
                              </span>
                            </div>

                            <ul className="ulFilterListData scrollable-list">
                              {uniqueGroupCourse
                                .filter((item) =>
                                  item.group_course_name
                                    ?.toLowerCase()
                                    .includes(searchGroupName.toLowerCase())
                                )
                                .map((el) => (
                                  <li
                                    className="filterListData"
                                    key={el.group_course_id}
                                  >
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={el.group_course_name}
                                      value={el.group_course_id}
                                      id={el.group_course_id}
                                      checked={groupCourse_on.some(
                                        (element) =>
                                          element.name === el.group_course_name
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          el.group_course_name,
                                          "groupCourse_on"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG"
                                      htmlFor={el.group_course_id}
                                    >
                                      {el.group_course_name}
                                    </label>
                                  </li>
                                ))}
                            </ul>
                          </div>

                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("groupCourse_on")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  onClick={() =>
                                    handleApplyFilter("groupCourseName")
                                  }
                                  className={`primaryButton ${
                                    groupCourse_on.length === 0
                                      ? "disabled"
                                      : ""
                                  }`}
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  <th id="th" ref={filterSubcategoryRef}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "subcategory")}
                    >
                      {" "}
                      Sub Category
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "subcategory")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      className={`textHead_th align-middle material-icons ${
                        subCategory_on.length > 0 || isOpen.subcategory
                          ? ListInfo.active_icons
                          : ""
                      }`}
                      onClick={(e) => handleFilter(e, "subcategory")}
                    >
                      filter_list
                    </span>
                    {isOpen.subcategory && (
                      <>
                        <div className="filterBoxs_testlist">
                          <div className="col-md-12 form-check filterStatus_list">
                            <ul className="ulFilterListData">
                              <div
                                class="input-group"
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 10,
                                  backgroundColor: "white",
                                  padding: "8px",
                                }}
                              >
                                {" "}
                                <input
                                  type="text"
                                  className={styles.Inputs}
                                  id="SearchInput"
                                  name="SearchInput"
                                  value={searchSubCategory}
                                  placeholder="Search by subject"
                                  onChange={(e) =>
                                    setSearchSubCategory(e.target.value)
                                  }
                                />
                                <span
                                  className={styles.input_group_text}
                                  id="SearchInput"
                                >
                                  <span className="material-icons">search</span>
                                </span>
                              </div>
                              {uniqueSubCategory
                                .filter((item) =>
                                  item.group_course_name
                                    ?.toLowerCase()
                                    .includes(searchSubCategory.toLowerCase())
                                )
                                .map((el) => (
                                  <li className="filterListData">
                                    <input
                                      className="ListCheckbox"
                                      type="checkbox"
                                      name={el.subcategory}
                                      value={el.subcategory_id}
                                      id={el.subcategory_id}
                                      checked={subCategory_on.some(
                                        (element) => {
                                          if (element.name == el.subcategory) {
                                            return true;
                                          }
                                          return false;
                                        }
                                      )}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          e,
                                          el.subcategory,
                                          "subCategory_on"
                                        )
                                      }
                                    />
                                    <label
                                      className="form-check-label filterChipText_withoutBG "
                                      htmlFor={el.subcategory_id}
                                    >
                                      {el.subcategory}
                                    </label>
                                  </li>
                                ))}
                            </ul>
                          </div>
                          <div className="borderWidth row">
                            <ul className="List-Button">
                              <li className="ListBtnItems">
                                <Link
                                  to={"javascript:void(0)"}
                                  onClick={() => handleClear("subCategory_on")}
                                  className="secondaryButton ms-2"
                                >
                                  Clear
                                </Link>
                              </li>
                              <li className="ListBtnItems">
                                <Link
                                  disabled={
                                    subCategory_on.length === 0 ? true : false
                                  }
                                  onClick={() =>
                                    handleApplyFilter("subCategory_on")
                                  }
                                  className="primaryButton"
                                >
                                  Apply Filter
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    )}
                  </th>
                  <th id="th">
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "created_dt")}
                    >
                      Created On
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "created_dt")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span className="textHead_th">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData?.map((course, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          className={`${styles.checkBox_input}`}
                          type="checkbox"
                          name="bookset_order"
                          id={`bookset_order_${course.id}`}
                          value={course.id}
                          checked={
                            Array.isArray(selectedCourse) &&
                            selectedCourse.some((b) => b?.id === course?.id)
                          }
                          onChange={(e) => handleChangeBookOrder(e, course.id)}
                        />
                      </td>
                      <td id="td">{course.serialNumber}</td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.course_name}
                        >
                          {course.course_name}
                        </span>
                      </td>
                      {course.type === 0 && (
                        <td id="td">
                          <span>Course</span>
                        </td>
                      )}
                      {course.type === 1 && (
                        <td id="td">
                          <span>Test Batch</span>
                        </td>
                      )}
                      {course.type === 2 && (
                        <td id="td">
                          <span>Counselling</span>
                        </td>
                      )}
                      {course.type === 3 && (
                        <td id="td">
                          <span>Special Class</span>
                        </td>
                      )}
                      {course.type === 4 && (
                        <td id="td">
                          <span>Model Exam </span>
                        </td>
                      )}
                      {course.type === 5 && (
                        <td id="td">
                          <span>Mock Interview </span>
                        </td>
                      )}
                      {course.type === 6 && (
                        <td id="td">
                          <span>_ </span>
                        </td>
                      )}
                      <td id="td">{course.category} </td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.group_course_name}
                        >
                          {course.group_course_name}
                        </span>
                      </td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={`${styles.ellipsis}`}
                          title={course.subcategory}
                        >
                          {course.subcategory}
                        </span>
                      </td>
                      {/* <td id="td">{course.category_code} </td> */}
                      {/* <td id="td"> {course.subcategory_code}</td> */}
                      <td id={`${styles.td}tabTh`}>
                        <span>
                          {course.created_dt
                            ? moment.utc(course.created_dt).format("DD-MM-YYYY")
                            : "-"}
                        </span>
                      </td>
                      <td id="td">
                        <button
                          className={"view_icon_button"}
                          // onClick={() => handleReadView(course.id)}
                          onClick={(e) =>
                            handleReadView(
                              course.id,
                              course.category,
                              course.type
                            )
                          }
                        >
                          <span className={` visibleicon material-icons`}>
                            visibility
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="row mt-2">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              updateListData && updateListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              updateListData && updateListData?.length > 0
                ? updateListData?.length < currentPage * rowsPerPage
                  ? updateListData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              updateListData && updateListData?.length > 0
                ? updateListData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1 || totalPages === 0}
            prevButton={`${ListInfo.prev_buttonViewEvaluator} ${ListInfo.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages || totalPages === 0}
          />
        </div>
      </div>
    </>
  );
}

export default ListCourseInfo;
